/**
 * Reduces a full request URL to a low-cardinality endpoint path suitable for a
 * Sentry fingerprint, so that requests to the same logical endpoint group into
 * one issue instead of exploding by id / query string.
 *
 * - Keeps only the pathname (drops origin + query string).
 * - Replaces numeric path segments with `{id}` so e.g. `/api/product/20702/`
 *   and `/api/product/9/` both become `/api/product/{id}/`.
 *
 * Returns explicit fallbacks (never throws) so the caller can fingerprint even
 * when the url is missing or unparsable.
 */
export function normalizeApiEndpoint(url: string | null): string {
  if (!url) {
    return '(no url)';
  }
  try {
    return new URL(url).pathname.replace(/\/\d+(?=\/|$)/g, '/{id}');
  } catch {
    return '(bad url)';
  }
}
